import { useTranslation } from 'react-i18next';

export default function LendingRecommendedSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.recommended.title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 hover:border-green-500 transition-all">
            <div className="mb-4">
              <img 
                src="https://mycoinlending.com/images/recs_1.jpg"
                alt={t('lending.recommended.item1.title')}
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-lg font-bold text-white text-center">
              {t('lending.recommended.item1.title')}
            </h3>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 hover:border-green-500 transition-all">
            <div className="mb-4">
              <img 
                src="https://mycoinlending.com/images/recs_2.jpg"
                alt={t('lending.recommended.item2.title')}
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-lg font-bold text-white text-center">
              {t('lending.recommended.item2.title')}
            </h3>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 hover:border-green-500 transition-all">
            <div className="mb-4">
              <img 
                src="https://mycoinlending.com/images/recs_3.jpg"
                alt={t('lending.recommended.item3.title')}
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-lg font-bold text-white text-center">
              {t('lending.recommended.item3.title')}
            </h3>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 hover:border-green-500 transition-all">
            <div className="mb-4">
              <img 
                src="https://mycoinlending.com/images/recs_4.jpg"
                alt={t('lending.recommended.item4.title')}
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-lg font-bold text-white text-center">
              {t('lending.recommended.item4.title')}
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
}
